import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Dropdown = ({ className, items, onItemSelect, isOpenInitially, activeItem, onDropdownSelect }) => {
  const [isOpen, setIsOpen] = useState(isOpenInitially || false);
  const [internalActiveItem, setInternalActiveItem] = useState(activeItem || items[0]);
  const [hoveredItem, setHoveredItem] = useState(null);

  useEffect(() => {
    if (activeItem && activeItem.value !== internalActiveItem.value) {
      setInternalActiveItem(activeItem);
    }
  }, [activeItem, internalActiveItem.value]);

  const toggleDropdown = useCallback(() => {
    setIsOpen(prevIsOpen => !prevIsOpen);
    onDropdownSelect(isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onDropdownSelect]);

  const handleItemSelect = useCallback((e, item) => {
    e.stopPropagation();
    e.preventDefault();

    setInternalActiveItem(item);
    onItemSelect(item);
    setIsOpen(false);
  }, [onItemSelect]);

  const handleMouseEnter = (item) => {
    if (item.subItems) {
      setHoveredItem(item.value);
    }
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const baseClass = className || 'ui-select';
  const activeClass = isOpen ? `${baseClass}--opened` : '';

  return (
    <div className="dropdown">
      <div className={`${baseClass} ${activeClass}`}>
        <div className={`${baseClass}__input`} onClick={toggleDropdown}>
          <span className={`${baseClass}__input-label`} />
          <span className={`${baseClass}__input-value`}>{internalActiveItem.label}</span>
        </div>
        <div className={baseClass + "__dropdown " + (isOpen ? baseClass + "__dropdown-opened" : "")}>
          {isOpen && (
            <ul className={`${baseClass}__dropdown-list`} style={{ maxHeight: '300px', overflow: 'visible' }}>
              {items.map((item, index) => {
                const isActive = item.value === internalActiveItem.value;
                return (
                  <li
                    key={index}
                    onClick={(e) => handleItemSelect(e, item)}
                    onMouseEnter={() => handleMouseEnter(item)}
                    onMouseLeave={handleMouseLeave}
                    className={`${baseClass}__dropdown-list-item` + (isActive ? ` ${baseClass}__dropdown-list-item--active` : "")}
                  >
                    {item.label}
                    {hoveredItem === item.value && item.subItems && (
                      <ul className={`ui-select__dropdown ${baseClass}__submenu`}>
                        {item.subItems.map((subItem, subIndex) => (
                          <li
                            key={`${index}-${subIndex}`}
                            onClick={(e) => handleItemSelect(e, subItem)}
                            className={`${baseClass}__dropdown-list-item`}
                          >
                            {subItem.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })).isRequired,
  onItemSelect: PropTypes.func.isRequired,
  onDropdownSelect: PropTypes.func.isRequired,
  isOpenInitially: PropTypes.bool,
  activeItem: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })
};

Dropdown.defaultProps = {
  activeItemIndex: 0 // По умолчанию первый элемент, если активный элемент не указан
};

export default Dropdown;
